export default "__VITE_ASSET__D1yF$K4$__"